import L from "leaflet";
import loc from "../../assets/loc.svg";

export const LIcon = new L.Icon({
  iconUrl: loc,
  iconSize: [40, 61],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});
